import { render, staticRenderFns } from "./ProfileAvatar.vue?vue&type=template&id=06361169&scoped=true"
import script from "./ProfileAvatar.vue?vue&type=script&lang=js"
export * from "./ProfileAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06361169",
  null
  
)

export default component.exports